import { useEffect } from 'react';

// Client-side navigation to /privacy, /terms or /cookie-notice never reaches Firebase Hosting's
// 301, so the router sends it to the served page on valutten.com instead (see config/legalUrls).
export default function LegalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}
